import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer-all-rights-reserved" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("p", null, [
      _createTextVNode("© "),
      _createElementVNode("em", { id: "copyright-year" }, "2023"),
      _createTextVNode(" Exive. All rights reserved.")
    ], -1)
  ]))]))
}